import { Component, computed, inject, input, signal } from '@angular/core';
import { FieldTree, FormField, SchemaPathTree } from '@angular/forms/signals';
import { match, none, Option, some } from '../../../../shared/functions/functional';
import { MceApiService, RCDDto } from '../../../../core/mceapi.client.generated';
import { MatSelectModule } from '@angular/material/select';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { rxResource } from '@angular/core/rxjs-interop';

export interface RCD {
  addRCD: boolean,
  rating: number;
}

export function buildRCDSchema(path: SchemaPathTree<RCD>) { }

export function createRCD(dto: Option<RCDDto>) {
  return signal<RCD>(
    match(
      () => ({ addRCD: false, rating: 30e-3 }),
      (x: RCDDto): RCD => {
        if (x.rating === undefined) {
          throw new Error('RCD DTO is missing its rating.');
        }

        return { addRCD: true, rating: x.rating };
      })(dto));
}

export function createRCDDto(model: FieldTree<RCD>) {
  return signal<Option<RCDDto>>(
    model.addRCD().value() === true
      ? some({ rating: model.rating().value() })
      : none);
}


@Component({
  selector: 'protection-rcd',
  imports: [FormField, MatSelectModule, MatCheckboxModule],
  templateUrl: './rcd.component.html',
})
export class RcdComponent {

  readonly form = input.required<FieldTree<RCD>>();
  private readonly mceApiService = inject(MceApiService);

  ratingsRx = rxResource({
    params: () => ({}),
    stream: () => this.mceApiService.v1ProtectionRatingsRcd()
  });
  ratings = computed(() => this.ratingsRx.value() ?? []);

}
